import * as bowser from 'bowser'

export class Device {
  static get isMobile(): boolean {
    return bowser.mobile
  }

  static get isTablet(): boolean {
    return bowser.tablet
  }

  static get isMobileOrTablet(): boolean {
    return bowser.mobile || bowser.tablet
  }

  static get isAndroid(): boolean {
    return bowser.android
  }

  static get isIOS(): boolean {
    return bowser.ios
  }

  static get os(): string {
    return bowser.osname
  }

  static get osversion(): string {
    return bowser.osversion as string
  }

  static get browser(): string {
    return bowser.name
  }

  static get deviceType(): 'tablet' | 'mobile' | 'desktop' {
    if (this.isTablet) {
      return 'tablet'
    } else if (this.isMobile) {
      return 'mobile'
    } else {
      return 'desktop'
    }
  }
}

export const mapDeviceToFlooring = (device: string) => {
  const map = { mobile: 'phone' }

  return map[device] || device
}
export const mapOsToFlooring = (os: string) => {
  const map = {
    Android: 'Android',
    iOS: 'ios'
  }

  return map[os] || 'Desktop'
}
